import { Cell, Grid, Heading, HFlow, Icon, InfoLabel } from 'bold-ui'
import { css } from 'emotion'
import { IvcfSubgrupoPerguntaEnum, RiscoVulnerabilidadeIvcfEnum } from 'graphql/types.generated'
import React from 'react'
import { formatDate } from 'util/date/formatDate'
import { isEmpty } from 'util/validation/Util'
import { IVCF_SUBGRUPOS } from 'view/atendimentos/detail/soap/objetivo/ivcf/model-ivcf'

import { colorLabel } from '../../table/OldAcompanhamentoCondicaoSaudeListing'

interface AcompanhamentoCondicaoSaudeIvcfAccordionPanelProps {
  riscoVulnerabilidade?: RiscoVulnerabilidadeIvcfEnum
  dataRegistro?: number
  subgrupos?: IvcfSubgrupoPerguntaEnum[]
}

export function AcompanhamentoCondicaoSaudeIvcfAccordionPanel(
  props: Readonly<AcompanhamentoCondicaoSaudeIvcfAccordionPanelProps>
) {
  const { riscoVulnerabilidade, dataRegistro, subgrupos } = props

  return (
    <Grid gap={0} gapVertical={0.5} alignItems='baseline' style={styles.content}>
      <Cell size={12}>
        <HFlow hSpacing={0.25} alignItems='center'>
          <Icon icon='fileWithItemsFilled' size={1} />
          <Heading level={4}>IVCF-20</Heading>
        </HFlow>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Risco' placeholder='-' titleStyles={styles.title}>
          {riscoVulnerabilidade && colorLabel(riscoVulnerabilidade)}
        </InfoLabel>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Registrado em' placeholder='-' titleStyles={styles.title}>
          {formatDate(dataRegistro)}
        </InfoLabel>
      </Cell>
      <Cell size={6}>
        <InfoLabel title='Dimensões alteradas' placeholder='-' titleStyles={styles.title}>
          {!isEmpty(subgrupos) && subgrupos?.map((subgrupo) => IVCF_SUBGRUPOS[subgrupo]?.label).join('; ') + '.'}
        </InfoLabel>
      </Cell>
    </Grid>
  )
}

const styles = {
  content: css`
    padding: 1rem 0;
  `,
  title: css`
    padding-bottom: 0.25rem;
  `,
}
